import {specialsWheels} from "../wheels/reducer/specialsWheels";
import {combineReducers} from "redux";

export default combineReducers({
	wheels: specialsWheels
});
